// extracted by mini-css-extract-plugin
export default {"rodape":"rodape_rodape__FHXhY"};